import React, { memo } from 'react'
import ContentLoader from 'react-content-loader'

const LayoutSwithingSkeleton = (props) => {
    return (
        <div className="cards-top-bar">
            <div className="container">
                <div className="cards-top-bar-wrapper">

                    <ContentLoader className="trip-layout-skeleton"
                        height={35}
                        width={'100%'}
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                    >
                        <rect x="0%" y="0%" rx="0" ry="0" width="15" height="27" /> {/*number */}
                        <rect x="2%" y="0%" rx="0" ry="0" width="35%" height="27" /> {/*label */}
                        
                        <rect x="60%" y="0%" rx="0" ry="0" width="30%" height="30" /> {/*sort */}
                    </ContentLoader>
                </div>
            </div>
        </div>

    )
}

export default memo(LayoutSwithingSkeleton)
